import {TweenMax, TimelineMax} from "gsap/TweenMax"
import { getAnimationData } from './animations/animations.js'


export function addHeaderAnimation(el, animationData) {

  if(!el) {
    return
  }

  let animDataArray = animationData.split(',')
  let animation = animDataArray[Math.floor(Math.random() * animDataArray.length)]
 
  let documentHeight = document.documentElement.clientHeight
  let windowHeight = window.innerHeight
  let scrollTop = 0

  const animationHolder = el.querySelector('.animated_elements')
  const animData = getAnimationData(animation)

  let hero = el.querySelector('.hero__product img')
  hero.src = animData.pageAssets.hero

  el.style.backgroundImage = `url(${animData.pageAssets.background})`

  const largeWidth = 1025
  const medWidth = 769
  const smallWidth = 375
  let animItems

  const addAnimatedElem = (obj) => {
    let img = new Image()
    img.src = obj.img

    let elem = document.createElement('div')
    elem.className = 'ld-animated-header-elem'

    elem.style.top = obj.y+'px'
    elem.style.left = obj.x+'%'
    if ( obj.r ) {
      elem.style.transform = 'rotate('+obj.r+'deg'
    }

    elem.classList.add('ld-animated-header-elem-' + obj.s)

    if ( obj.mobile == false ) {
        elem.classList.add('mobile-hide')
    }

    animationHolder.append(elem)

    img.onload = ()=> {
      elem.style.width = img.naturalWidth*2
      elem.style.height = img.naturalHeight*2
      elem.appendChild(img)
    }

    animItems = Array.from(el.querySelectorAll('.ld-animated-header-elem'))
  }

  for (let obj of animData.animation) {
    addAnimatedElem(obj)
  }

  let timeline1 = new TimelineMax({paused:true})
  let timeline2 = new TimelineMax({paused:true})

  var scrollEl = window,
      docEl = document.documentElement,
      docBody = document.body
  if ( window.matchMedia('(min-device-width: '+largeWidth+'px)').matches ) {
      scrollEl = docEl = docBody = document.querySelector('.content-wrapper')
  }

  let stopTimeline = false
  if ( window.matchMedia('(min-device-width: '+largeWidth+'px)').matches ) {
    scrollEl.addEventListener('scroll', (e)=> {
        let h = docEl,
            b = docBody,
            st = 'scrollTop',
            sh = 'scrollHeight'

        var clientHeight = h.clientHeight
        if ( window.matchMedia('(min-device-width: '+largeWidth+'px)').matches ) {
            clientHeight = h.offsetHeight
        }
        let scrollPercent = ((h[st]||b[st])*10) / ((h[sh]||b[sh]) - clientHeight)

        var contentPromo = document.querySelector('.content-promo')
        if ( scrollEl.scrollTop >= 200 ) {
            el.classList.add('unfix')
            if ( contentPromo ) {
                contentPromo.classList.add('unfix')
            }
        } else {
            el.classList.remove('unfix')
            if ( contentPromo ) {
                contentPromo.classList.remove('unfix')
            }
        }
        if(scrollPercent > 0 && stopTimeline != true) {
          timeline1.progress(scrollPercent).pause()
          timeline2.progress(scrollPercent).pause()
        }

        if(scrollPercent > 1) {
          stopTimeline = true
        }
    })
  }

  const checkBigEnough = () => {
    timeline1.remove()
    timeline2.remove()

    timeline1 = new TimelineMax({paused:true})
    timeline2 = new TimelineMax({paused:true})

    var scaleFrom = 1,
        scaleTo = 0.3,
        top = "70%",
        left = "45%"

    if ( window.matchMedia('(min-device-width: '+smallWidth+'px)').matches ) {
        scaleFrom = 0.65
        scaleTo = 0.1
        top = "84%"
        left = "45%"
    }
    if ( window.matchMedia('(min-device-width: '+medWidth+'px)').matches ) {
        scaleFrom = 0.7
        scaleTo = 0.2
        top = "70%"
        left = "45%"
    }
    if ( window.matchMedia('(min-device-width: '+largeWidth+'px)').matches ) {
        scaleFrom = 0.9
        scaleTo = 0.3
        top = "72%"
        left = "45%"
    }

    timeline1.staggerFromTo('.ld-animated-header-elem-left', 2, {scale:scaleFrom}, {scale:scaleTo, top:top, left:left, rotation: -180}, .05 )
    timeline2.staggerFromTo('.ld-animated-header-elem-right', 2, {scale:scaleFrom}, {scale:scaleTo, top:top, left:left, rotation: 180}, .05 )
  }

  window.addEventListener('resize', checkBigEnough, false)
  checkBigEnough()

}



// WEBPACK FOOTER //
// ./src/header-animation.js